export const getters = {
  getConversations: _state => _state.records,
  getConversationById: _state => id => {
    const convId = Number(id);
    return (
      _state.records.find(c => c.id === convId) ||
      _state.supervisedConversations.find(c => c.id === convId)
    );
  },
  getMessagesByConversationId: _state => id => _state.messages[id] || [],
  getUIFlags: _state => _state.uiFlags,
  getUnreadCount: _state => {
    return _state.records.reduce(
      (total, conv) => total + (conv.unread_count || 0),
      0
    );
  },
  getSupervisedConversations: _state => _state.supervisedConversations,
  getSupervisedUser: _state => _state.supervisedUser,
};
